import { TeamRepository } from '../repositories';

export class AcceptTeamInvitationUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(invitationId: string, inviteeId: string, teamId: string): Promise<void> {
    await this.teamRepository.updateInvitationStatus(invitationId, 'accepted');
    await this.teamRepository.addMember(teamId, inviteeId);
  }
}
